<template>
  <div>
    <div class="rec-hd">
      <div class="rec-cap">相关招聘信息</div>
      <div class="rec-hd-btn m-h mla" @click="winStatus = true">联系HR</div>
    </div>
    <div class="rec-list">
      <div class="list-hd">
        <div class="list-hd-tab">招聘岗位</div>
        <div class="list-hd-tab">工作地点</div>
        <div class="list-hd-tab">所属部门</div>
      </div>
      <div
        v-for="(item, index) in list"
        :key="index"
        class="list-item"
        :class="{ on: ind === index }"
        @click="ind = index"
      >
        <div class="list-item-hd m-h">
          <div class="list-tab">{{ item.name }}</div>
          <div class="list-tab">{{ item.address }}</div>
          <div class="list-tab">{{ item.department }}</div>
        </div>
        <div class="list-item-bd">
          <div class="list-item-bd-cap">岗位职责</div>
          <div class="list-item-bd-text" v-html="item.responsibility"></div>
          <div class="list-item-bd-cap">任职要求</div>
          <div class="list-item-bd-text" v-html="item.requirement"></div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="rec-win" v-if="winStatus">
        <div class="rec-win-make" @click="winStatus = false"></div>
        <div class="rec-win-box">
          <div class="rec-win-cap">招聘专线</div>
          <div class="rec-win-text" v-html="temp_1"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import pageMain_mx from "../mixins/pageMain_mx";

export default {
  mixins: [pageMain_mx],
  data() {
    return {
      winStatus: false,
      ind: "",
      temp_1: ""
    };
  },
  mounted() {},
  methods: {
    async init() {
      this.$api.cms.web.jobPosition_listForClient.get().then(res => {
        this.list = res.data;
      });
      this.temp_1 = await this.getMenuConfig("招聘专线", "title");
    },
    show() {
      this.winStatus = true;
    }
  }
};
</script>
<style lang="less">
.rec-hd {
  display: flex;
  align-items: center;
  margin-top: 50px;
}
.rec-cap {
  color: #282828;
  font-size: 20px;
}
.rec-hd-btn {
  color: #ffffff;
  text-align: center;
  width: 90px;
  height: 36px;
  line-height: 36px;
  background: rgba(253, 143, 93, 1);
  border-radius: 4px;
}
.rec-list {
  margin-top: 18px;
  .list-hd {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #e0e0e0;
  }
  .list-hd-tab {
    width: 215px;
    flex-shrink: 0;
    color: #979797;
    font-size: 16px;
    text-align: center;
  }
  .list-item {
    &.on {
      .list-item-hd {
        &:after {
          transform: rotate(90deg);
        }
      }
      .list-item-bd {
        display: block;
      }
    }
  }
  .list-item-hd {
    display: flex;
    align-items: center;
    padding: 32px 0;
    border-bottom: 1px solid #e0e0e0;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      right: 59px;
      margin-top: -10px;
      background: url("../assets/img/ico_27.png") no-repeat;
      width: 11px;
      height: 20px;
    }
  }
  .list-tab {
    width: 215px;
    flex-shrink: 0;
    color: #606060;
    font-size: 16px;
    text-align: center;
  }
  .list-item-bd {
    display: none;
    padding: 0 60px 30px 60px;
    border-bottom: 1px solid #e0e0e0;
  }
  .list-item-bd-cap {
    color: #282828;
    font-size: 18px;
    margin-top: 30px;
  }
  .list-item-bd-text {
    color: #979797;
    font-size: 16px;
    line-height: 1.8;
    margin-top: 8px;
  }
}
.rec-win {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
  display: flex;
}
.rec-win-make {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  background: rgba(0, 0, 0, 1);
  opacity: 0.3;
}
.rec-win-box {
  margin: auto;
  width: 477px;
  padding-bottom: 48px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 1);
}
.rec-win-cap {
  color: #282828;
  font-size: 20px;
  text-align: center;
  margin-top: 44px;
}
.rec-win-text {
  color: #979797;
  font-size: 18px;
  text-align: center;
  margin-top: 30px;
  p {
    & + p {
      margin-top: 27px;
    }
  }
}
</style>
